(function () {
	const initProductAccordion = (root = document) => {
		root.querySelectorAll(".about__accordion-toggle").forEach((toggle) => {
			if (toggle.dataset.productAccordionInitialized === "true") return;

			const panel = toggle.parentElement?.querySelector(".about__accordion-description");
			if (!panel) return;

			toggle.dataset.productAccordionInitialized = "true";
			toggle.setAttribute("aria-expanded", toggle.classList.contains("active") ? "true" : "false");

			toggle.addEventListener("click", () => {
				const isOpen = toggle.classList.toggle("active");
				toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
				panel.style.display = isOpen ? "block" : "none";
			});
		});
	};

	document.addEventListener("shopify:section:load", (event) => {
		initProductAccordion(event.target);
	});

	initProductAccordion();
})();
